<template>
  <div class="feeInvoicingCompany">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="gardenId" @change="getListHouse" disabled>
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="zero"></el-option>
            <el-option
              v-for="(item,index) in types"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="searchSellerName"
            placeholder="销方名称"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" v-if="isFeeManager===1" @click="add">新增开票公司</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="id" :label="'ID'" v-if="false"></el-table-column>
        <el-table-column prop="sellerName" label="销方名称"></el-table-column>
        <el-table-column prop="unifiedSocialCreditCode" label="统一社会信用代码"></el-table-column>
        <el-table-column prop="sellerAddress" label="销售方地址"></el-table-column>
        <el-table-column prop="sellerBank" label="销方开户银行"></el-table-column>
        <el-table-column prop="bankAccount" label="银行账号"></el-table-column>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | timeYMD }}</template>
        </el-table-column>
        <el-table-column v-if="isFeeManager===1" width="150" prop="operation" :label="$t('lang.lab_operation')">
          <template slot-scope="scope">
            <el-button  @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" v-if="isFeeManager===1" @click="deletetable(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
    <el-dialog
      :title="title"
      :visible.sync="isPopupPage"
      :close-on-click-modal="false"
      center
      top="5px !important"
      width="800px"
      @closed="handleDialogClosed"
    >
      <el-form
        :model="diaForm"
        :rules="rules"
        ref="diaForm"
        :label-width="require('@/config/enum').c_ws8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item label="销方名称" prop="sellerName">
          <el-input
            placeholder="请输入销方名称"
            v-model="diaForm.sellerName"
          ></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="unifiedSocialCreditCode">
          <el-input
            placeholder="请输入统一社会信用代码"
            v-model="diaForm.unifiedSocialCreditCode"
          ></el-input>
        </el-form-item>
        <el-form-item label="销售方地址" prop="sellerAddress">
          <el-input
            placeholder="请输入销售方地址"
            v-model="diaForm.sellerAddress"
          ></el-input>
        </el-form-item>
        <el-form-item label="销方开户银行" prop="sellerBank">
          <el-input
            placeholder="请输入销方开户银行"
            v-model="diaForm.sellerBank"
          ></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="bankAccount">
          <el-input
            placeholder="请输入银行账号"
            v-model="diaForm.bankAccount"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear('diaForm')">{{$t('lang.btn_rest')}}</el-button>
        <!--保存-->
        <el-button
          type="primary"
          @click="save('diaForm')"
          :disabled="isDisabled"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:feeInvoicingCompany 开票公司配置
 *@Description:开票公司配置管理
 *@author:
 *@Copyright:格众科技
 *@date:2024
 */
export default {
  name: '/manage/main.feeInvoicingCompany',
  data() {
    return {
      isFeeManager: 0,
      zero: 0, // 值为0的变量
      multipleSelection: [], // 多选框
      pageCount: 0, // 总页数
      title: '', // 弹框显示的标题
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      types: [], // 小区下拉
      tableData: [], // 列表数组
      searchSellerName: '', // 搜索的关键字
      disabled: true,
      editId: '', // 编辑按钮保存的id
      isPopupPage: false, // 弹框的显示控制
      saveData: '', // 存储json字符串
      diaForm: {
        sellerName: '',
        unifiedSocialCreditCode: '',
        sellerAddress: '',
        sellerBank: '',
        bankAccount: ''
      },
      rules: {
        sellerName: [
          {
            required: true,
            message: '请输入销方名称',
            trigger: 'blur',
          },
        ],
        unifiedSocialCreditCode: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur',
          },
        ],
        sellerAddress: [
          {
            required: true,
            message: '请输入销售方地址',
            trigger: 'blur',
          },
        ],
        sellerBank: [
          {
            required: true,
            message: '请输入销方开户银行',
            trigger: 'blur',
          },
        ],
        bankAccount: [
          {
            required: true,
            message: '请输入银行账号',
            trigger: 'blur',
          },
        ],
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      isDisabled: true, // 保存的可点击
      gardenId: 0, // 小区绑定的id
    }
  },
  created() {
    console.log(this.$store.getters)
		this.gardenId = this.$store.getters.gardenId
    this.isFeeManager = this.$store.getters.isFeeManager
    this.getGarden()
    this.getTablelist()
  },
  watch: {
    diaForm: {
      handler(newVal, oldVal) {
        // form数据变化时 会调用此方法
        let tempRule = JSON.stringify(newVal)
        if (tempRule == this.saveData) {
          // 没变
          this.isDisabled = true
        } else {
          // 变了
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取列表
    getTablelist() {
      let loading = this.$loading()
      this.$get(
        `/feeInvoiceCompanyConfigList/?gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}&sellerName=${this.searchSellerName}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    commit() {
      this.pageNo = 1
      this.getTablelist()
    },
    // 弹框点击取消按钮
    clear(diaForm) {
			this.$refs[diaForm].resetFields()
      this.diaForm.sellerName = ''
      this.diaForm.unifiedSocialCreditCode = ''
      this.diaForm.sellerAddress = ''
      this.diaForm.sellerBank = ''
      this.diaForm.bankAccount = ''
      setTimeout(() => {
        this.$refs[diaForm].clearValidate()
      }, 0)
    },
    getGarden() {
      let myGardens = [...this.$store.getters.userGardenList]
      let index = myGardens.findIndex(item => item.id === 0)
      if (index != -1) {
        myGardens.splice(index, 1)
      }
      this.types = myGardens
    },
    // 添加
    add() {
      this.diaForm.sellerName = ''
      this.diaForm.unifiedSocialCreditCode = ''
      this.diaForm.sellerAddress = ''
      this.diaForm.sellerBank = ''
      this.diaForm.bankAccount = ''
      this.editId = ''
      this.isDisabled = false
      this.isPopupPage = true

      this.title = '新增开票公司'
      this.$nextTick(() => {
          this.$refs.diaForm.clearValidate()
      })
    },
    // 编辑
    edit(row) {
      this.title = '编辑开票公司'
      this.editId = row.id
      this.$get(`/feeInvoiceCompanyConfig/${this.editId}`).then(
        (res) => {
          if (res && res.errCode === 0) {
            this.diaForm = res.data
            this.saveData = JSON.stringify(this.diaForm)
            console.log(res)
          }
        },
        (error) => {
          this.$message.error(error)
        }
      )
      this.isPopupPage = true
    },
    // 添加/保存按下确定
    save(diaForm) {
      if (this.editId === '') {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let params = {
              gardenId: this.gardenId,
              sellerName: this.diaForm.sellerName,
              unifiedSocialCreditCode: this.diaForm.unifiedSocialCreditCode,
              sellerAddress: this.diaForm.sellerAddress,
              sellerBank: this.diaForm.sellerBank,
              bankAccount: this.diaForm.bankAccount
            }
            let loading = this.$loading()
            this.$post(`/feeInvoiceCompanyConfig`, params).then(
              (res) => {
                loading.close()
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.isPopupPage = false
                this.commit()
              },
              (error) => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      } else {
        this.$refs[diaForm].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            let params = {
              gardenId: this.gardenId,
              sellerName: this.diaForm.sellerName,
              unifiedSocialCreditCode: this.diaForm.unifiedSocialCreditCode,
              sellerAddress: this.diaForm.sellerAddress,
              sellerBank: this.diaForm.sellerBank,
              bankAccount: this.diaForm.bankAccount
            }
            this.$patch(`/feeInvoiceCompanyConfig/${this.editId}`, params).then(
              (res) => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.isPopupPage = false
                  this.commit()
                }
              },
              (error) => {
                loading.close()
                this.$message.error(error)
                this.isPopupPage = false
              }
            )
          } else {
            return false
          }
        })
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.getTablelist()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.getTablelist()
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.diaForm.resetFields()
      this.diaForm.sellerName = ''
      this.diaForm.unifiedSocialCreditCode = ''
      this.diaForm.sellerAddress = ''
      this.diaForm.sellerBank = ''
      this.diaForm.bankAccount = ''
      this.isPopupPage=false
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 获取小区下的楼号
    getListHouse() {
      // 预留方法
    },
    deletetable(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => {
          // 添加del的url
          this.$delete(`/feeInvoiceCompanyConfig/` + id).then(
            (res) => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success'),
                })
                this.commit()
              }
            },
            (error) => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can'),
          })
        })
    },
  },
}
</script>

<style lang="scss">
.el-dialog .el-form .el-form-item {
  margin-right: 0;
  margin-bottom: 15px !important;
  text-align: left;
}
</style>
